import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const privateRoutes = new Set(["files", "editor", "delivery", "account", "admin"]);

export function RouteMetadata() {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();
  const route = routeKey(pathname);

  useEffect(() => {
    const title = t(`metadata.${route}.title`);
    const description = t(`metadata.${route}.description`);
    document.title = title;
    setMeta("description", description);
    setMeta("robots", privateRoutes.has(route) ? "noindex,nofollow" : "index,follow");
    setPropertyMeta("og:title", title);
    setPropertyMeta("og:description", description);
    setPropertyMeta("og:type", "website");
    const canonical = ensureCanonical();
    canonical.href = `${window.location.origin}${pathname}`;
  }, [i18n.language, pathname, route, t]);

  return null;
}

function routeKey(pathname: string): string {
  if (pathname.startsWith("/editor/")) return "editor";
  if (pathname.startsWith("/legal/terms")) return "terms";
  if (pathname.startsWith("/legal/privacy")) return "privacy";
  if (pathname.startsWith("/legal/refund")) return "refund";
  if (pathname.startsWith("/tools/subtitles")) return "tools";
  return pathname.split("/").filter(Boolean)[0] ?? "home";
}

function setMeta(name: string, content: string): void {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.name = name;
    document.head.append(element);
  }
  element.content = content;
}

function setPropertyMeta(property: string, content: string): void {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[property="${property}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("property", property);
    document.head.append(element);
  }
  element.content = content;
}

function ensureCanonical(): HTMLLinkElement {
  let element = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!element) {
    element = document.createElement("link");
    element.rel = "canonical";
    document.head.append(element);
  }
  return element;
}
